import { DateTime as DateTime$1 } from "../../DateTime/index.js";
import { useDevice } from "../../../hooks/useDevice.js";
import { useGeolocation } from "../../../hooks/useGeolocation.js";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Button, FormControlWrapper, Icon, Loading } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdUpdate } from "react-icons/md";
//#region src/components/GeoCoordinates/shared/GeoCoordinatesInput.tsx
var GeoCoordinatesInput = (props) => {
	const [local, setLocal] = useState({
		initialValue: props.value,
		waitingOnRefresh: !props.value
	});
	const [value, setValue] = useState(props.value);
	const device = useDevice();
	const geo = useGeolocation();
	useEffect(() => {
		if (!local.waitingOnRefresh || !geo.timestamp) return;
		setLocal((prev) => ({
			...prev,
			waitingOnRefresh: false
		}));
		setValue({
			accuracy: geo.accuracy || 0,
			coords: {
				lat: geo.latitude,
				lng: geo.longitude
			},
			device,
			timestamp: geo.timestamp
		});
	}, [
		device,
		geo,
		local.waitingOnRefresh
	]);
	useEffect(() => {
		if (value !== props.value) props?.onChangeValue?.(value);
	}, [value, props]);
	const [accuracyDescription, geoStateError] = useMemo(() => {
		const accuracy = value?.accuracy || 99999;
		let _accuracyDescription = `GPS accuracy is poor`;
		if (accuracy <= 1600) _accuracyDescription = `${accuracy} meters accuracy`;
		else if (accuracy <= 500) _accuracyDescription += ` (${accuracy}m)`;
		let _getStateError;
		if (geo.error) {
			const errorMessages = {
				PERMISSION_DENIED: "GPS permission denied by user/device",
				POSITION_UNAVAILABLE: "System unable to fetch GPS",
				TIMEOUT: "System took too long fetching GPS, timeout error"
			};
			if (geo.error.PERMISSION_DENIED) _getStateError = errorMessages.PERMISSION_DENIED;
			else if (geo.error.POSITION_UNAVAILABLE) _getStateError = errorMessages.POSITION_UNAVAILABLE;
			else if (geo.error.TIMEOUT) _getStateError = errorMessages.TIMEOUT;
			else _getStateError = "Unknown GPS error";
		}
		return [_accuracyDescription, _getStateError];
	}, [geo, value]);
	const refresh = useCallback(() => {
		setLocal((prev) => ({
			...prev,
			waitingOnRefresh: true
		}));
		geo.refresh();
	}, [geo]);
	const accuracy = geo.accuracy || 0;
	return /* @__PURE__ */ jsx(FormControlWrapper, {
		error: props.error || geoStateError,
		hint: props.hint,
		inputName: "geocoords",
		label: props.label || "GPS Coordinates",
		subText: props.subText,
		children: /* @__PURE__ */ jsxs("div", {
			className: "bg-surface-strong p-xs text-color-subtle relative rounded",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "inline-flex w-full justify-between",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "flex flex-col",
					children: [value?.timestamp && /* @__PURE__ */ jsxs("div", {
						className: "inline-flex",
						children: [/* @__PURE__ */ jsx(DateTime$1, { timestamp: value.timestamp }), /* @__PURE__ */ jsxs("span", {
							className: "ml-2 font-bold",
							children: [
								"(",
								/* @__PURE__ */ jsx(DateTime$1, {
									relative: true,
									timestamp: value.timestamp
								}),
								")"
							]
						})]
					}), /* @__PURE__ */ jsx("div", {
						className: classnames({
							"text-color-caution": accuracy > 250 && accuracy <= 750,
							"text-color-critical": accuracy > 750
						}),
						children: accuracyDescription
					})]
				}), /* @__PURE__ */ jsx(Button, {
					onClick: refresh,
					children: /* @__PURE__ */ jsx(Icon, { Icon: MdUpdate })
				})]
			}), geo.loading && /* @__PURE__ */ jsx(Loading, {
				message: "Loading GPS coordinates",
				overlay: true,
				size: "sm"
			})]
		})
	});
};
//#endregion
export { GeoCoordinatesInput };

//# sourceMappingURL=GeoCoordinatesInput.js.map